export const COUNTRY_BY_NAME = 'mac/FETCH_COUNTRY_BY_NAME';
